export default {
  props: {
    title: {
      default: "Título",
    },
    text: "",
    image: "",
    alt: "",
  },
};
